import React from 'react';

const SkillItem = ({ title, percent }) => (
    <li className="mb-3">
        <strong className="o-font-sm font-weight-normal">{title}</strong>
        <div className="progress">
            <div className="progress-bar o-bg-purple" role="progressbar" style={{width: `${percent}%`}} aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </li>
);

class Skills extends React.Component{

    state = {
        skills: [
            {id: 1, title: 'PEDULI', percent: '25'},
            {id: 2, title: 'BAIK HATI', percent: '50'},
            {id: 3, title: 'INTROVERT', percent: '75'},
            {id: 4, title: 'INDOENSIA', percent: '100'},
            {id: 5, title: 'PEMBOHONG', percent: '25'},
            {id: 6, title: 'PINTAR', percent: '50'},
            {id: 7, title: 'OVERSHARING', percent: '75'},
            {id: 8, title: 'HAPPY &  DEPRESSION', percent: '100'},
        ]
    }

    render(){
        return(
            <>
                <ul className="list-unstyled mb-5 o-grid">
                    {
                        this.state.skills.map(item => (
                            <SkillItem key={item.id} {...item} />
                        ))
                    }
                </ul>
            </>
        );
    }
}

export default Skills;